/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantHealthNotifications
 */
export interface TenantHealthNotifications {
    /**
     * 
     * @type {number}
     * @memberof TenantHealthNotifications
     */
    ios_sent_7d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthNotifications
     */
    ios_failed_7d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthNotifications
     */
    android_sent_7d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthNotifications
     */
    android_failed_7d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthNotifications
     */
    ios_sent_30d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthNotifications
     */
    ios_failed_30d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthNotifications
     */
    android_sent_30d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthNotifications
     */
    android_failed_30d?: number;
}

/**
 * Check if a given object implements the TenantHealthNotifications interface.
 */
export function instanceOfTenantHealthNotifications(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantHealthNotificationsFromJSON(json: any): TenantHealthNotifications {
    return TenantHealthNotificationsFromJSONTyped(json, false);
}

export function TenantHealthNotificationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantHealthNotifications {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ios_sent_7d': !exists(json, 'ios_sent_7d') ? undefined : json['ios_sent_7d'],
        'ios_failed_7d': !exists(json, 'ios_failed_7d') ? undefined : json['ios_failed_7d'],
        'android_sent_7d': !exists(json, 'android_sent_7d') ? undefined : json['android_sent_7d'],
        'android_failed_7d': !exists(json, 'android_failed_7d') ? undefined : json['android_failed_7d'],
        'ios_sent_30d': !exists(json, 'ios_sent_30d') ? undefined : json['ios_sent_30d'],
        'ios_failed_30d': !exists(json, 'ios_failed_30d') ? undefined : json['ios_failed_30d'],
        'android_sent_30d': !exists(json, 'android_sent_30d') ? undefined : json['android_sent_30d'],
        'android_failed_30d': !exists(json, 'android_failed_30d') ? undefined : json['android_failed_30d'],
    };
}

export function TenantHealthNotificationsToJSON(value?: TenantHealthNotifications | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ios_sent_7d': value.ios_sent_7d,
        'ios_failed_7d': value.ios_failed_7d,
        'android_sent_7d': value.android_sent_7d,
        'android_failed_7d': value.android_failed_7d,
        'ios_sent_30d': value.ios_sent_30d,
        'ios_failed_30d': value.ios_failed_30d,
        'android_sent_30d': value.android_sent_30d,
        'android_failed_30d': value.android_failed_30d,
    };
}

